import { Injectable, Param, Query } from "@nestjs/common";
import { Repository, Raw, getConnection, getManager } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { ErrorResponse, MessageRequest } from '@gtpl/shared-models/common-models';
import { QcDefect } from "./qc-defect-entity";
import { QcDefectAdapter } from "./dto/qc-defect-adapter";
import { QcDefectDto } from "./dto/qc-defect.dto";
import { AllQcDefectResponseModel, OperationTestnameresponse, Qcdefectdto, QcdefectResponsemodel, QcdefectWorkstaionResponse, QcdefectworkstationNameResponseModell, WorkstationRequest } from "@gtpl/shared-models/production-management";
import { QcDefectRequest, TestNameforoperationrequest, TestNameforoperationrequestQrScan, WorkstationCoderequest, workstationforOperation } from "./dto/qc-defect-request";
import appSettings from "apps/services/config";
import { CommonResponse, UnitTypeEnum } from "@gtpl/shared-models/masters";
import { QcdefectItemDetailsRequest, QcdefectReportRequest } from "./dto/defect-report-request";
@Injectable()
export class QcDefectService{
    constructor(
        @InjectRepository(QcDefect)
        private qcdefectRepository:Repository<QcDefect>,
        private qcdefectAdapter:QcDefectAdapter,

    ){ }

    async createQcDefect(qcdefectDto: QcDefectDto, isUpdate: boolean): Promise<QcdefectResponsemodel> {
        try{
        const convertedqcdefectEntity: QcDefect = this.qcdefectAdapter.convertDtoToEntity(qcdefectDto,isUpdate);
          const savedqcdefectEntity: QcDefect = await this.qcdefectRepository.save(
            convertedqcdefectEntity
          );
          const savedqcdefectdto: QcDefectDto = this.qcdefectAdapter.convertEntityToDto(convertedqcdefectEntity);
            // console.log(savedStateDto);
          if (savedqcdefectdto) {
            // generating resposnse
            const response = new QcdefectResponsemodel(true,1,isUpdate? 'QcDefect Details Updated Successfully': 'QcDefect Details Created Successfully')
            return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new QcdefectResponsemodel(false,11106,'QcDefect Details saved but issue while transforming into DTO');
          }
        }
        catch(err){
            return err;

        }

    }
    async getAllQcDefectDetails(req?:QcdefectReportRequest): Promise<AllQcDefectResponseModel> {
        try {
          const manager = getManager();
          let query = 'SELECT qd.qc_id AS qcId,qd.workstation_id AS workstationId,qp.test_name AS testName,qd.operation_id AS operationId,qd.lot_number AS lotNumber,inspected_count AS inspectedCount,inspected_quantity AS inspectedQuantity,passed_quantity AS passedQuantity, test_result AS testResult,w.workstation AS workstation,qd.is_active AS isActive,qd.created_at AS createdAt,qp.test_name AS testName,qd.created_user AS createdUser,qd.updated_at AS updatedAt,qd.updated_user AS updatedUser,qd.version_flag AS versionFlag,operation_name AS operationName  FROM '+appSettings.production_db+'.qc_defect_details qd LEFT JOIN '+appSettings.production_db+'.qa_qc_operations qp ON qd.testresult_Id = qp.qa_qc_op_id LEFT JOIN '+appSettings.production_db+'.operations o ON qd.operation_id=o.operation_id LEFT JOIN '+appSettings.production_db+'.workstations w ON qd.workstation_id=w.workstation_id where qd.qc_id > 0';
          
          if(req.lotNumber!=undefined){
            query=query + ' and qd.lot_number="'+req.lotNumber+'"'
          }if(req.workstationId){
            query=query+' AND qd.workstation_id ='+req.workstationId
          }
          if(req.operationId){
            query=query+' AND qd.operation_id='+req.operationId
          }if(req.testResultId){
            query=query+' AND qd.testresult_Id='+req.testResultId
          }
          
          const result: QcDefectDto[] = await manager.query(query)
          if (result.length>0) {
            return new AllQcDefectResponseModel(true, 1111, "Data retreived sucesssfuly", result)
          } else {
            return new AllQcDefectResponseModel(false, 1111, "Error occure")
    
          }
    
        } catch (err) {
          return err;
        }
      }

      async getAllActiveQcDefectDetails(): Promise<AllQcDefectResponseModel> {
        // const page: number = 1;
        try {
            const qcDefecDto: QcDefectDto[] = [];
            //retrieves all companies
            const QcdefectEntities: QcDefect[] = await this.qcdefectRepository.find({ order: { 'lotNumber': 'ASC' },where:{isActive:true},
           });
         console.log(QcdefectEntities)
            if (QcdefectEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                QcdefectEntities.forEach(QcdefectEntity => {
                    const convertedqcDefectDto: QcDefectDto = this.qcdefectAdapter.convertEntityToDto(
                      QcdefectEntity
                      
                    );
                    qcDefecDto.push(convertedqcDefectDto);
                });
                const response = new AllQcDefectResponseModel(true, 11108, "QcDefect Details retrieved successfully", qcDefecDto);
                return response;
            } else {
                throw new QcdefectResponsemodel(false,99998, 'Data not found'); qcDefecDto
            }
        } catch (err) {
            return err;
        }
    }

    async getQcDefectDetailsById(qcId: number): Promise<QcDefect> {
      //  console.log(employeeId);
          const Response = await this.qcdefectRepository.findOne({
          where: {qcId: qcId},
          });
          // console.log(employeeResponse);
          if (Response) {
          return Response;
          } else {
          return null;
          }
      }


    async activateOrDeactivateQcDefectDetails(qcDefectdetailsReq: QcDefectRequest): Promise<QcdefectResponsemodel> {
      try {
          const QcdefectdetailsExists = await this.getQcDefectDetailsById(qcDefectdetailsReq.qcId);
          if (QcdefectdetailsExists) {
              if (qcDefectdetailsReq.versionFlag !== QcdefectdetailsExists.versionFlag) {
                  throw new QcdefectResponsemodel(false,10113, 'Someone updated the current QcDefcetDetails information.Refresh and try again');
              } else {
                  
                      const qcdefectdetailsStatus =  await this.qcdefectRepository.update(
                          { qcId: qcDefectdetailsReq.qcId },
                          { isActive: qcDefectdetailsReq.isActive,updatedUser: qcDefectdetailsReq.updatedUser });
                     
                      if (QcdefectdetailsExists.isActive) {
                          if (qcdefectdetailsStatus.affected) {
                              const qcdefectDetailsResponse: QcdefectResponsemodel = new QcdefectResponsemodel(true, 10115, 'QcDefect Details is de-activated successfully');
                              return qcdefectDetailsResponse;
                          } else {
                              throw new QcdefectResponsemodel(false,10111, 'Qcdefect details is already deactivated');
                          }
                      } else {
                          if (qcdefectdetailsStatus.affected) {
                              const qcDefectResponse: QcdefectResponsemodel = new QcdefectResponsemodel(true, 10114, 'QcDefect Details is activated successfully');
                              return qcDefectResponse;
                          } else {
                              throw new QcdefectResponsemodel(false,10112, 'QcDefect Details is already  activated');
                          }
                      }
                  // }
              }
          } else {
              throw new QcdefectResponsemodel(false,99998, 'No Records Found');
          }
      } catch (err) {
          return err;
      }
  }


  async getActiveQcDefectById(qcdefectReq: QcDefectRequest): Promise<QcdefectResponsemodel> {
    try {
      //retrieves all companies
      const QcDefectDetailsEntities: QcDefect = await this.qcdefectRepository.findOne({
          where:{qcId:qcdefectReq.qcId}
          });
          
          const QcdefectDetailsData: QcDefectDto = this.qcdefectAdapter.convertEntityToDto(QcDefectDetailsEntities);
          if (QcdefectDetailsData) {
              const response = new QcdefectResponsemodel(true, 11101 , 'QcDefect details retrived Successfully',QcdefectDetailsData);
              return response;
          }
          else{
              throw new QcdefectResponsemodel(false,11106,'Something went wrong');
          }
          // generating resposnse
  } catch (err) {
      return err;
  }
}
async getWorkstation(req?:WorkstationCoderequest): Promise <QcdefectworkstationNameResponseModell> {
  try{
const manager = getManager();
const query = 'SELECT workstation_id as workstationId,workstation AS workstation FROM ' + appSettings.production_db +'.workstations WHERE workstation_code= "' + req.workstationCode + '"'
const result:QcdefectWorkstaionResponse []= await manager.query(query)
if(result){
  return new QcdefectworkstationNameResponseModell(true, 1111, "Data retreived sucessfully",result)

}else{
  return new QcdefectworkstationNameResponseModell(false, 1111, "Error occure")

}
  }
  catch(err){
  return err;
  }


}
async getTestnameforOperation(req:TestNameforoperationrequest):Promise<CommonResponse>{
try{
  const manager=getManager();
  const query = 'SELECT test_name as testName,test_code AS testCode,qa_qc_op_id AS qaQcTestId FROM '+appSettings.production_db+'.qa_qc_operations WHERE operation_id=' + req.operationId
  const result =await manager.query(query)
  if(result){
    return new CommonResponse(true, 1111, "Data retreived sucessfully",result)
  
  }else{
    return new CommonResponse(false, 1111, "Error occure")
  
  }
    }
    catch(err){
    return err;
    }
  
}
async getAllActiveWorkstation(req?:workstationforOperation):Promise<CommonResponse>{
  try{
      const manager=getManager();
      const plantquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.plantId;
        const plantresult =await manager.query(plantquery);
      let query=' SELECT p.workstation AS workStationId,w.workstation AS workstation,workstation_code as workstationCode,operation,lot_number AS lotNumber,job_status,sale_order_id AS saleOrderId,sale_order_item_id AS saleOrderItemId,sub_plant_id,plant_id FROM '+appSettings.production_db+'.production_log p LEFT JOIN '+appSettings.production_db+'.workstations w ON p.workstation=w.workstation_id WHERE p.job_status="NO" and operation="'+req.operationName+'" and sub_lot_number="'+req.subLotNumber+'" and p.lot_number="'+req.lotNumber+'" and sale_order_item_id='+req.saleOrderItemId+' and sale_order_id='+req.saleOrderId+'  AND p.workstation IS NOT NULL '
      if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
        query = query+' and sub_plant_id='+req.plantId+''
     }else{
        query = query+' and plant_id='+req.plantId+' and sub_plant_id=0'
     }
     query=query+'  GROUP BY p.workstation'
      // const query = 'SELECT workstation_id as workStationId,workstation AS workstation,workstation_code as workstationCode FROM ' + appSettings.production_db +'.workstations where workstation_id ='+req.workstationCategory+''
      const result =await manager.query(query)
      if(result){
        return new CommonResponse(true, 1111, "Data retreived sucessfully",result)
      
      }else{
        return new CommonResponse(false, 1111, "Error occure")
      
      }
        }
        catch(err){
        return err;
        }
      
}

async getAllLotnumbers():Promise<CommonResponse>{
  try{
    const manager=getManager();
    const query = 'SELECT lot_number AS lotNumber FROM '+appSettings.production_db+'.qc_defect_details group by lot_number '
    const result =await manager.query(query)
    if(result){
      return new CommonResponse(true, 1111, "Data retreived sucessfully",result)
    
    }else{
      return new CommonResponse(false, 1111, "Error occure")
    
    }
      }
      catch(err){
      return err;
      }
    
  }
  async getTestnameforOperationForScan(req:TestNameforoperationrequestQrScan):Promise<CommonResponse>{
    try{
      const manager=getManager();
      const query = 'SELECT test_name as testName,test_code AS testCode,qa_qc_op_id AS testResultId FROM '+appSettings.production_db+'.qa_qc_operations WHERE operation_id=' + req.testCode
      const result =await manager.query(query)
      if(result){
        return new CommonResponse(true, 1111, "Data retreived sucessfully",result)
      
      }else{
        return new CommonResponse(false, 1111, "Error occure")
      
      }
        }
        catch(err){
        return err;
        }
      
    }
    async getTestNameForReport():Promise<CommonResponse>{
      try{
        const manager=getManager();
        const query = 'SELECT test_name as testName,qa_qc_op_id AS testResultId FROM '+appSettings.production_db+'.qa_qc_operations' 
        const result =await manager.query(query)
        if(result){
          return new CommonResponse(true, 1111, "Data retreived sucessfully",result)
        
        }else{
          return new CommonResponse(false, 1111, "Error occure")
        
        }
          }
          catch(err){
          return err;
          }
        
      }

      async getQcdefectItemByQcId(req:QcdefectItemDetailsRequest):Promise<CommonResponse>{
        const manager=getManager();
        const query='SELECT qc_defect_item_id AS qcdefectitemId,qc_id AS qcId,testresult_id AS testResultId,rejected_quantity AS rejectedQuantity,test_name AS testName FROM '+appSettings.production_db+'.qc_defect_items q LEFT JOIN '+appSettings.production_db+'.qa_qc_operations o ON q.testresult_id=o.qa_qc_op_id where qc_id='+req.qcId+'';
        const result=await manager.query(query)
        if(result){
          return new CommonResponse(true,1111,"Data retrieved Sucessfully",result)
        }else{
          return new CommonResponse(false,1111,"Error Occure")
        }

      }
}

